// 계약 고객 링크 화면이 쓰는 순수 값 — 브라우저도 읽으므로 build-share(lib/hash → node:crypto)에 닿지 않는다.

const HASH_SHOWN = 12;

export const shortHash = (hash: string | null): string => (hash ?? "").slice(0, HASH_SHOWN);
